import { useEffect } from 'react';

// click out side
const UseClickOutSide = (ref: any, callback: any) => {
  // on click
  const onClick = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  // use effect
  useEffect(() => {
    const page = document.querySelector(".page");
    page?.addEventListener("click", onClick);

    return () => {
      page?.removeEventListener("click", onClick);
    };
  });
};

export default UseClickOutSide;